import {Component, input} from "@angular/core";
import {Navbar} from "../navbar/navbar";

@Component({
  selector: "app-header",
  templateUrl: "./header.html",
  styleUrl: "./header.scss",
  imports: [
    Navbar,
  ],
})
export class Header {
  public readonly backgroundImage = input<string>();
  public readonly title = input.required<string>();
  public readonly description = input<string>();
}
